import Vue from 'vue'

const Fluxes = {
  namespaced: true,

  state: {
    flux: {},
    fluxes: [],
    fluxName: null
  },

  mutations: {
    setFluxes(state, fluxes) {
      state.fluxes = fluxes || []
    },
    setFlux(state, flux) {
      state.flux = flux || {}
      state.fluxName = state.flux.name
    }
  },

  actions: {
    async getAll({ commit }, { search } = {}) {
      const params = { search }
      const response = await Vue.axios.get('/fluxes', { params })
      const fluxes = response.data.data
      commit('setFluxes', fluxes)
    },
    async get({ commit }, id) {
      let flux = { status: 'enabled' }
      if (id) {
        const response = await Vue.axios.get(`/flux/${id}`)
        flux = response.data.data
      }
      commit('setFlux', flux)
    },
    async createOrUpdate({ commit, state }) {
      let response
      if (state.flux.id) {
        response = await Vue.axios.put(`/flux/${state.flux.id}`, state.flux)
      } else {
        response = await Vue.axios.post('/flux', state.flux)
      }
      commit('setFlux', response.data.data)
    }
  }
}

export default Fluxes
